import { getReferrer } from '../../src/util/getReferrer';

export const trackPageView = () => {
  // Never update document.referrer directly as other anayltics platforms (e.g. GA) use it for attribution.
  // Instead, save it in the window.zola global so it can be referenced by other track events.
  const referrer = getReferrer(window.document.referrer);
  if (window && window.zola) {
    window.zola.referrer = referrer;
  }

  const currentRoute = window.location || {};
  const path = currentRoute && currentRoute.pathname;
  const search = currentRoute && currentRoute.search;
  const url = window && window.location && window.location.href;
  const nextRoutePageContext = {
    path: path || '',
    referrer,
    search: search || '',
    title: document && document.title,
    url: url || '',
  };

  // Send the page view event if analytics are available
  if (window.analytics) {
    window.analytics.page(nextRoutePageContext);
  }
};

export default () => null;
